import React from 'react'
import PropTypes from 'prop-types'
import { ProgressBar as Bar } from 'react-bootstrap'

const ProgressBar = ({ progress, size = 'sm', label, animated, variant = 'primary' }) => (
  <div className='row d-flex align-items-center'>
    <div className='col px-2'>
      <Bar
        now={progress}
        variant={variant}
        animated={animated}
        bsPrefix={`${size}-progress progress`}
      />
    </div>
    {
      label &&
      <div className={`p-0 text-center ${size}-progress-text fw-bold`} style={{
        width: size === 'sm'
          ? '35px'
          : size === 'xs'
            ? '25px'
            : '39px'
      }}>
        <span>{progress >= 100 ? '100' : progress < 0 ? '0' : progress}%</span>
      </div>
    }
  </div>
)

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  size: PropTypes.oneOf(['sm', 'xs']),
  label: PropTypes.bool,
  animated: PropTypes.bool,
  variant: PropTypes.string
}

export default ProgressBar
